/**
 * DOCS => https://github.com/knpwrs/string-score
 */
export default class EmailValidator {
    constructor(Vue) {
        this._arrayDomain = ["gmail.com", "hotmail.com", "hotmail.com.br", "yahoo.com.br", "yahoo.com", "bol.com.br", "outlook.com", "outlook.com.br", "uol.com.br", "adapcon.com.br"]
        this._arrayDomainEnd = ["com", "com.br", "net", "org", "org.br"]
        
        this.validate = (userEmail) => {
            const email = userEmail.toLowerCase();
            
            const emailSplitAt = email.split("@");
            const user = emailSplitAt[0];
            const domain = emailSplitAt[1];
            const domainEnd = domain.split(".").slice(1).join(".");

            let arrayScoreDomain = this._getArrayScore(this._arrayDomain, domain, 0.5, 0.5);
            let arrayScoreDomainEnd = this._getArrayScore(this._arrayDomainEnd, domainEnd, 0.9, 0.5);
            
            /* Tratamento manual para casos em que a comparação não atinge parâmetros mínimos */
            arrayScoreDomain = this._domainManualValidation(domain, arrayScoreDomain);
            arrayScoreDomainEnd = this._domainEndManualValidation(domainEnd, arrayScoreDomainEnd);
            
            if (arrayScoreDomain.length > 0 && arrayScoreDomain[0].score < 1)
                return `${user}@${arrayScoreDomain[0].option}`;
            else if (arrayScoreDomainEnd.length > 0 && arrayScoreDomainEnd[0].score < 1)
                return `${user}@${domain.split(".")[0]}.${arrayScoreDomainEnd[0].option}`;
            else 
                return null;
        }

        this._getArrayScore = (arrayCompare, value, fuzziness, minimumScore) => {
            let arrayScore = [];
            
            arrayCompare.forEach(compare => {
                const scoreCalculated = score(compare, value, fuzziness);
                
                if (scoreCalculated > minimumScore) {
                    arrayScore.push({
                        option: compare,
                        score: scoreCalculated
                    });
                }
            })

            if (arrayScore.length > 0) {
                arrayScore.sort((a, b) => {
                    return b.score - a.score;
                })
            }

            return arrayScore;
        }

        this._domainManualValidation = (domain, arrayScoreDomain) => {
            if (domain == "hotmaol.com") arrayScoreDomain.push({
                option: "hotmail.com",
                score: 0.99
            });

            if (domain == "hotamail.com") arrayScoreDomain.push({
                option: "hotmail.com",
                score: 0.99
            });
            
            if (domain == "gmail.com.br") arrayScoreDomain.push({
                option: "gmail.com",
                score: 0.99
            });
            
            if (domain == "uhoo.com.br") arrayScoreDomain.push({
                option: "yahoo.com.br",
                score: 0.99
            });

            if (domain == "uotlook.com.br") arrayScoreDomain.push({
                option: "outlook.com.br",
                score: 0.99
            });

            if (domain == "uotlook.com") arrayScoreDomain.push({
                option: "outlook.com",
                score: 0.99
            });

            return arrayScoreDomain;
        }

        this._domainEndManualValidation = (domainEnd, arrayScoreDomainEnd) => {
            return arrayScoreDomainEnd;
        }
    }
}